module.exports = __webpack_public_path__ + "assets/icon-set.9e36c129.svg";